import React, { PureComponent, Fragment } from 'react';
import { Alert, Spin } from 'antd';
import { queryUacMenu } from '../services/user';
import pageRoutes from '../../config/router.config.js';
import { getAllAllowedRoutes, getRouterConfigPath, getRouteFilterByUac } from '../utils/routerUtil';

export default class UacEntry extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      uacMenusList: [], // UAC节点数据
      allAllowedRoutes: [], // 鉴权的UAC路由
      allConfigRouterPath: [], // 所有config.router中的路由
    };
  }
  async componentDidMount() {
    const { route } = this.props || {};
    let uacMenuRes = {};
    try {
      uacMenuRes = await queryUacMenu();
    } catch (e) {
      console.warn('UAC鉴权接口失败');
    }
    const uacMenusList = uacMenuRes.menuFolderList || [];
    const allAllowedRoutes = getAllAllowedRoutes(uacMenusList);

    // 通过uac menu返回的数据过滤router.config中的路由,和app.js中的patchRoutes过滤路由互斥，二者只需一个
    route.routes = getRouteFilterByUac(route.routes, allAllowedRoutes);
    // 过滤路由end
    let checkUacRoutes = []; //生成所有的pageRoutes中需检查鉴权的路由
    pageRoutes &&
      pageRoutes.forEach(item => {
        checkUacRoutes = checkUacRoutes.concat(item.checkUac && item.routes ? item.routes : []);
      });
    const allConfigRouterPath = getRouterConfigPath(checkUacRoutes);
    this.setState({ uacMenusList, allAllowedRoutes, allConfigRouterPath, loading: false });
  }
  checkIsUacRouter = () => {
    const {
      location: { pathname },
    } = this.props;
    return this.state.allAllowedRoutes.indexOf(pathname) === -1;
  };
  checkIsActivePath = () => {
    const {
      location: { pathname },
    } = this.props;
    return this.state.allConfigRouterPath.indexOf(pathname) > -1;
  };
  render() {
    const { children, route, location } = this.props;
    const { loading } = this.state;
    const isActivePath = this.checkIsActivePath();
    const isUnPassUac = isActivePath && this.checkIsUacRouter();
    if (loading || isUnPassUac) {
      return (
        <div style={{ width: '100vw', height: '100vh' }}>
          <div
            style={{
              margin: '10vw auto',
              textAlign: 'center',
            }}
          >
            {isUnPassUac ? (
              <Alert
                type="info"
                message={
                  <>
                    <div>当前系统无权限，</div>
                    <div>
                      请前往{' '}
                      <a>
                        https://iam.sankuai.com/access-permission?activeKey=system-access&field=add
                      </a>{' '}
                      申请「POI-MDC平台」系统权限
                    </div>
                  </>
                }
                banner
              />
            ) : (
              <Spin tip="权限认证中，请稍候..." />
            )}
          </div>
        </div>
      );
    } else {
      return <Fragment>{children}</Fragment>;
    }
  }
}
